<div
  class="nav-bar"
  [class.nav-bar_is-collapsed]="isSideBarCollapsed()"
  appAddClassModifier
>
  @if (navBarGroups.length > 0) {
    <div class="nav-bar__container">
      @for (group of navBarGroups; track group) {
        <div class="nav-bar__group">
          <app-nav-group [group]="group.name" [items]="group.items" />
        </div>
      }
    </div>
  } @else {
    <div class="nav-bar__container">
      <div class="nav-bar__message">No Results Found</div>
    </div>
  }
</div>
